import React from 'react';
import styled from "styled-components";

const StyledSettings = styled.div`
    display: flex; 
    flex-direction: column;
    h4{
        margin-bottom: 8px; 
    }
`
const Divider = styled.div`
    width: 100%;
    height: 1px; 
    background-color: #377879;
    border-radius: 50%;
    margin-bottom: 24px; 
`
const SettingsSection = styled.div`
    display: flex;
    flex-direction: column; 
    margin-bottom: 1rem;
`;
const Toggle = styled.div`
    display: flex; 
    flex-direction: row; 
    justify-content: space-between;
    p{
        margin-right: 20px; 
    }
`
const StyledToggleButton = styled.div`
    display: block;
    position: relative; 
    div.background{
        position: relative; 
        width: 44px; 
        height: 24px; 
        border-radius: 20px;
        background-color: #377879;
        z-index: 0; 
    }

    div.indicator{
        position: absolute; 
        top: 2px;
        right: 2px; 
        width: 20px;
        height: 20px; 
        border-radius: 20px; 
        background-color: #fff;
        z-index: 99; 
    }
    div.backgroundClicked{
        position: relative; 
        width: 44px; 
        height: 24px; 
        border-radius: 20px;
        background-color: #909090;
        z-index: 0; 
    }

    div.indicatorClicked{
        position: absolute; 
        top: 2px;
        left: 2px; 
        width: 20px;
        height: 20px; 
        border-radius: 20px; 
        background-color: #fff;
        z-index: 99; 
    
    }

`

class ToggleButton extends React.Component {
    constructor(props){
        super(props);
        this.state = {active: true}
        this.toggleClass = this.toggleClass.bind(this);
    }


    toggleClass() {
        this.setState({
            isActive: !this.state.isActive
          })
          console.log(this.state.isActive)
    };

    

    render() {
        return (
            <StyledToggleButton onClick={this.toggleClass} >
                <div className={this.state.isActive===true ? 'background' :'backgroundClicked'}></div>
                <div className={this.state.isActive===true ? 'indicator' :'indicatorClicked'}></div>
            </StyledToggleButton>
        )
      }
}

class Settings extends React.Component {
    render() {
        return (
            <StyledSettings>
                <h4>Notifications</h4>
                <Divider/>
                <SettingsSection>
                    <Toggle><p>Email me when I get a new message</p><ToggleButton/></Toggle>
                    <Toggle><p>Text me when I get a new message</p><ToggleButton/></Toggle>
                </SettingsSection>
                {/* <h4>Personalization</h4> */}
                {/* <Divider/> */}
                {/* <SettingsSection>
                    <p>Language</p>
                    <p>Accent Color</p>
                </SettingsSection> */}
            </StyledSettings>
        );
      }
}

export default class SettingsClass extends React.Component {
    render() {
      return (
          <Settings></Settings>
      );
    }
  }